<template>
  <div class="container">
    <div class="main-content">
      <div class="page-header">
        <h2 class="header-title">Заявление</h2>
      </div>

      <!-- Content goes Here -->

      <form action="#" @submit.prevent="formSubmit">
        <div class="stepBlock">
          <div class="stepBlock__item">
            <div class="card shadow-lg">
              <div class="card-body">
                <div class="form-group">
                  <label for="select_1_1">Факультет <span>*</span></label>
                  <select
                    class="custom-select"
                    id="select_1_1"
                    v-model="fak.val"
                    @change="fakSelect"
                    :disabled="false"
                    required
                  >
                    <option value="0" selected disabled>
                      -- выбрать факультет --
                    </option>
                    <template v-if="fak.items != null">
                      <option
                        v-for="item in fak.items"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name_kg }}
                      </option>
                    </template>
                  </select>
                </div>
                <div class="form-group">
                  <label for="select_1_11">Багыт <span>*</span></label>
                  <select
                    class="custom-select"
                    id="select_1_11"
                    v-model="direction.val"
                    @change="directionSelect"
                    :disabled="!fak.val"
                    required
                  >
                    <option value="0" selected disabled>
                      -- выбрать направления --
                    </option>
                    <template v-if="direction.items != null">
                      <option
                        v-for="item in direction.items"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name_kg }}
                      </option>
                    </template>
                  </select>
                </div>

                <div class="form-group">
                  <label for="select_1_2">Адистик <span>*</span></label>
                  <select
                    class="custom-select"
                    id="select_1_2"
                    v-model="spec.val"
                    @change="specSelect"
                    :disabled="!direction.val"
                    required
                  >
                    <option value="0" selected disabled>
                      -- выбрать специальность --
                    </option>
                    <template v-if="spec.items != null">
                      <option
                        v-for="item in spec.items"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name_kg }}
                      </option>
                    </template>
                  </select>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="select_1_4">Окуу тиби<span>*</span></label>
                      <select
                        class="custom-select"
                        id="select_1_4"
                        v-model="type_o.val"
                        @change="type_oSelect"
                        :disabled="!spec.val"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="type_o.items != null">
                          <option
                            v-for="item in type_o.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="select_1_5"
                        >Окуу формасы <span>*</span></label
                      >
                      <select
                        class="custom-select"
                        id="select_1_5"
                        v-model="f_o.val"
                        :disabled="!type_o.val"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="f_o.items != null">
                          <option
                            v-for="item in f_o.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="select_1_6">Окуу тили <span>*</span></label>
                      <select
                        class="custom-select"
                        id="select_1_5"
                        v-model="lang"
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="map.lang != null">
                          <option
                            v-for="item in map.lang"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="stepBlock__item">
            <div class="card shadow-lg">
              <div class="card-header d-flex justify-content-between py-3">
                <span class="h_tema_3 mb-0">Жеке маалымат</span>
                <span class="h_tema_3 mb-0"><i class="fas fa-user"></i></span>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-auto flex-grow-1">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="in_2_1"
                          >Фамилиясы <span>*</span></label
                        >
                      </div>
                      <input
                        type="text"
                        class="form-control text-right"
                        v-model="user.f"
                        placeholder="Эшматов"
                        id="in_2_1"
                        required
                      />
                    </div>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="in_2_2"
                          >Аты <span>*</span></label
                        >
                      </div>
                      <input
                        type="text"
                        class="form-control text-right"
                        v-model="user.i"
                        placeholder="Ташмат"
                        id="in_2_2"
                        required
                      />
                    </div>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="in_2_3"
                          >Атасынын аты</label
                        >
                      </div>
                      <input
                        type="text"
                        class="form-control text-right"
                        v-model="user.o"
                        placeholder="Полотович"
                        id="in_2_3"
                      />
                    </div>
                  </div>
                  <div class="col-auto">
                    <FotoBlock
                      :imgDefault="foto34_file.d"
                      :iwidth="foto34_file.w"
                      :iheight="foto34_file.h"
                      :status="foto34_file.status"
                      @img64="foto34_filem"
                      :aspectRatio="3/4"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="in_2_4"
                          >Туулган датасы <span>*</span></label
                        >
                      </div>
                      <input
                        type="date"
                        class="form-control text-right"
                        v-model="birthday"
                        placeholder=""
                        id="in_2_4"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="select_2_1"
                          >Жынысы<span>*</span></label
                        >
                      </div>
                      <select
                        class="custom-select"
                        id="select3"
                        required
                        v-model="male"
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="map.male != null">
                          <option
                            v-for="item in map.male"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="select_2_2"
                          >Улуту<span>*</span></label
                        >
                      </div>
                      <select
                        class="custom-select"
                        id="select4"
                        required
                        v-model="nationality"
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="map.nationality != null">
                          <option
                            v-for="item in map.nationality"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="h_tema_4 mb-2">Паспорт:</div>
                <div class="row">
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <label class="input-group-text" for="in_2_5"
                              >Серия/№ <span>*</span></label
                            >
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            v-model="number_passport"
                            placeholder=""
                            id="in_2_5"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <label class="input-group-text" for="in_2_6"
                              >Берген орган, датасы <span>*</span></label
                            >
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            v-model="info_passport"
                            placeholder=""
                            id="in_2_6"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="in_2_7"
                          >Жеке идент. номер (ПИН) <span>*</span></label
                        >
                      </div>
                      <input
                        type="text"
                        class="form-control text-right"
                        v-model="pin"
                        placeholder=""
                        id="in_2_7"
                        oninput="this.value = this.value.substr(0,14)"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row">
                      <div class="col">
                        <FotoBlock
                          :imgDefault="passport1_file.d"
                          :iwidth="passport1_file.w"
                          :iheight="passport1_file.h"
                          :ititle="passport1_file.t"
                          :status="passport1_file.status"
                          @img64="passport1_filem"
                        />
                      </div>
                      <div class="col">
                        <FotoBlock
                          :imgDefault="passport2_file.d"
                          :iwidth="passport2_file.w"
                          :iheight="passport2_file.h"
                          :ititle="passport2_file.t"
                          :status="passport2_file.status"
                          @img64="passport2_filem"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <label class="input-group-text" for="select_2_9"
                      >Гражданство <span>*</span></label
                    >
                  </div>
                  <select
                    class="custom-select"
                    id="select_2_9"
                    v-model="citizenship.val"
                    :disabled="citizenship.disabled"
                    required
                  >
                    <option value="0" selected disabled>---</option>
                    <template v-if="citizenship.items != null">
                      <option
                        v-for="item in citizenship.items"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name_kg }}
                      </option>
                    </template>
                  </select>
                </div>
                <div class="h_tema_4 mb-2">Туулган жери:</div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="select_2_3"
                          >Мамлекет <span>*</span></label
                        >
                      </div>
                      <select
                        class="custom-select"
                        id="select_2_3"
                        v-model="place.country.val"
                        @change="placeCounterSelect"
                        :disabled="false"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="place.country.items != null">
                          <option
                            v-for="item in place.country.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name_kg }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="select_2_31"
                          >Область <span>*</span></label
                        >
                      </div>
                      <select
                        class="custom-select"
                        id="select_2_31"
                        v-model="place.oblast.val"
                        @change="placeOblastSelect"
                        :disabled="!place.country.val"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="place.oblast.items != null">
                          <option
                            v-for="item in place.oblast.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name_kg }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="select_2_4"
                          >Район / Шаар<span>*</span></label
                        >
                      </div>
                      <select
                        class="custom-select"
                        id="select_2_4"
                        v-model="place.rayon.val"
                        :disabled="!place.oblast.val"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="place.rayon.items != null">
                          <option
                            v-for="item in place.rayon.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name_kg }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="in_2_8"
                          >Айылы / Адресс</label
                        >
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        id="in_2_8"
                        v-model="adress"
                      />
                    </div>
                  </div>
                </div>
                <div class="h_tema_4 mb-2">Жашаган жери:</div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="select_2_3"
                          >Мамлекет <span>*</span></label
                        >
                      </div>
                      <select
                        class="custom-select"
                        id="select_2_3"
                        v-model="live.country.val"
                        @change="liveCounterSelect"
                        :disabled="false"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="live.country.items != null">
                          <option
                            v-for="item in live.country.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name_kg }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="select_2_31"
                          >Область <span>*</span></label
                        >
                      </div>
                      <select
                        class="custom-select"
                        id="select_2_31"
                        v-model="live.oblast.val"
                        @change="liveOblastSelect"
                        :disabled="!live.country.val"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="live.oblast.items != null">
                          <option
                            v-for="item in live.oblast.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name_kg }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="select_2_4"
                          >Район / Шаар<span>*</span></label
                        >
                      </div>
                      <select
                        class="custom-select"
                        id="select_2_4"
                        v-model="live.rayon.val"
                        :disabled="!live.oblast.val"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="live.rayon.items != null">
                          <option
                            v-for="item in live.rayon.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name_kg }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <label class="input-group-text" for="in_2_8"
                          >Айылы / Адресс</label
                        >
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        id="in_2_8"
                        v-model="adress_live"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="stepBlock__item">
            <div class="card shadow-lg">
              <div class="card-header d-flex justify-content-between py-3">
                <span class="h_tema_3 mb-0"
                  >Бүтүргөн мектеби/окуу жайы боюнча маалымат:</span
                >
                <span class="h_tema_3 mb-0"><i class="fas fa-school"></i></span>
              </div>
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="select_3_1">Мамлекет <span>*</span></label>
                      <select
                        class="custom-select"
                        id="select_3_1"
                        v-model="edu.country.val"
                        @change="counterSelect"
                        :disabled="false"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="edu.country.items != null">
                          <option
                            v-for="item in edu.country.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name_kg }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="select_3_2">Область <span>*</span></label>
                      <select
                        class="custom-select"
                        id="select_3_2"
                        v-model="edu.oblast.val"
                        @change="oblastSelect"
                        :disabled="!edu.country.val"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="edu.oblast.items != null">
                          <option
                            v-for="item in edu.oblast.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name_kg }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="select_3_3"
                        >Шаар / Район <span>*</span></label
                      >
                      <select
                        class="custom-select"
                        id="select_3_3"
                        v-model="edu.rayon.val"
                        @change="rayontSelect"
                        :disabled="!edu.oblast.val"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="edu.rayon.items != null">
                          <option
                            v-for="item in edu.rayon.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name_kg }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label for="select_3_4"
                        >Мектептин аталышы<span>*</span></label
                      >
                      <select
                        class="custom-select"
                        id="select_3_4"
                        v-model="edu.mektep.val"
                        :disabled="!edu.rayon.val"
                        required
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="edu.mektep.items != null">
                          <option
                            v-for="item in edu.mektep.items"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name_kg }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label for="select_3_5"
                        >Бүтүргөн жылы <span>*</span></label
                      >
                      <select
                        class="custom-select"
                        id="select_3_5"
                        v-model="school_year_end"
                        required
                      >
                        <option
                          v-for="i in 70"
                          :key="i"
                          :value="new Date().getFullYear() - i + 1"
                          :selected="
                            new Date().getFullYear() - i + 1 == graduation
                          "
                        >
                          {{ new Date().getFullYear() - i + 1 }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="in_3_3"
                        >Аттестат/диплом серия, №<span>*</span></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="in_3_3"
                        v-model="diplom_info"
                        placeholder=""
                        oninput="this.value = this.value.substr(0,13)"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label for="select_3_6">Окуган чет тили</label>
                      <select
                        class="custom-select"
                        id="select_3_6"
                        required
                        v-model="language_studied"
                      >
                        <option value="0" selected disabled>---</option>
                        <template v-if="map.language_studied != null">
                          <option
                            v-for="item in map.language_studied"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-auto mb-3">
                    <label for="">Аттестат 1 <span>*</span></label>
                    <FotoBlock
                      :imgDefault="attestat1_file.d"
                      :iwidth="attestat1_file.w"
                      :iheight="attestat1_file.h"
                      :status="attestat1_file.status"
                      @img64="attestat1_filem"
                    />
                  </div>
                  <div class="col-auto mb-3">
                    <label for="">Аттестат 2 <span>*</span></label>
                    <FotoBlock
                      :imgDefault="attestat2_file.d"
                      :iwidth="attestat2_file.w"
                      :iheight="attestat2_file.h"
                      :status="attestat2_file.status"
                      @img64="attestat2_filem"
                    />
                  </div>
                  <div class="col-auto mb-3">
                    <label for="">Аттестат 3 </label>
                    <FotoBlock
                      :imgDefault="attestat3_file.d"
                      :iwidth="attestat3_file.w"
                      :iheight="attestat3_file.h"
                      :status="attestat3_file.status"
                      @img64="attestat3_filem"
                    />
                  </div>
                  <div class="col-auto mb-3">
                    <label for="">Аттестат 4 </label>
                    <FotoBlock
                      :imgDefault="attestat4_file.d"
                      :iwidth="attestat4_file.w"
                      :iheight="attestat4_file.h"
                      :status="attestat4_file.status"
                      @img64="attestat4_filem"
                    />
                  </div>
                  <div class="col-auto mb-3">
                    <label for="">PDF файл </label>
                    <Fileinput :url="perevod_file.d" @isFile="pdfFile" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="stepBlock__item">
            <div class="card shadow-lg">
              <div class="card-header d-flex justify-content-between py-3">
                <span class="h_tema_3 mb-0">ОРТ боюнча маалымат:</span>
                <span class="h_tema_3 mb-0"><i class="fas fa-school"></i></span>
              </div>
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="in_3_5">Сертификат №</label>
                          <input
                            type="text"
                            class="form-control"
                            id="in_3_5"
                            v-model="ort_number"
                            placeholder=""
                            oninput="this.value = this.value.replace(/[^\d]/,'').substr(0,8)"
                          />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="select_3_7">Категория</label>
                          <select
                            class="custom-select"
                            id="select_3_7"
                            v-model="ort_type"
                          >
                            <option value="0" selected disabled>---</option>
                            <template v-if="map.ort_type != null">
                              <option
                                v-for="item in map.ort_type"
                                :key="item.id"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </template>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="in_3_8"
                            >Негизги баллы<span>*</span></label
                          >
                          <input
                            type="text"
                            class="form-control"
                            id="in_3_8"
                            v-model="ort_ball1"
                            placeholder=""
                            oninput="this.value = this.value.replace(/[^\d]/,'').substr(0,3)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-9">
                        <div class="form-group">
                          <label for="select_3_10">Кошумча предмет 1</label>
                          <select
                            class="custom-select"
                            id="select_3_10"
                            v-model="ort_ball2_name"
                          >
                            <option value="0" selected disabled>---</option>
                            <template v-if="map.ort_predmet_name != null">
                              <option
                                v-for="item in map.ort_predmet_name"
                                :key="item.id"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </template>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="in_3_11">Баллы</label>
                          <input
                            type="text"
                            class="form-control"
                            id="in_3_11"
                            v-model="ort_ball2"
                            placeholder=""
                            oninput="this.value = this.value.replace(/[^\d]/,'').substr(0,3)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-9">
                        <div class="form-group">
                          <label for="select_3_12">Кошумча предмет 2</label>
                          <select
                            class="custom-select"
                            id="select_3_12"
                            v-model="ort_ball3_name"
                          >
                            <option value="0" selected disabled>---</option>
                            <template v-if="map.ort_predmet_name != null">
                              <option
                                v-for="item in map.ort_predmet_name"
                                :key="item.id"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </template>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="in_3_13">Баллы</label>
                          <input
                            type="text"
                            class="form-control"
                            id="in_3_13"
                            v-model="ort_ball3"
                            placeholder=""
                            oninput="this.value = this.value.replace(/[^\d]/,'').substr(0,3)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <label for="select_3_12">ОРТ</label>
                    <FotoBlock
                      :imgDefault="ort_file.d"
                      :iwidth="ort_file.w"
                      :iheight="ort_file.h"
                      :status="ort_file.status"
                      @img64="ort_filem"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="stepBlock__item">
            <div class="card shadow-lg">
              <div class="card-header d-flex justify-content-between py-3">
                <span class="h_tema_3 mb-0"
                  >Аскердик билет/Приписной(Күбөлүк):</span
                >
                <span class="h_tema_3 mb-0"
                  ><i class="fas fa-warehouse"></i
                ></span>
              </div>
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-md-7">
                    <div class="form-group">
                      <label for="in_4_1">Серия/№</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="voen_bilet_number"
                        id="in_4_1"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group">
                      <label for="in_4_2">Берилген датасы / Берген орган</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="voen_bilet_info"
                        id="in_4_2"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="row">
                      <div class="col-md-6">
                        <label for="select_3_5">Күбөлүк 1 <span>*</span></label>
                        <FotoBlock
                          :imgDefault="voen_b1_file.d"
                          :iwidth="voen_b1_file.w"
                          :iheight="voen_b1_file.h"
                          :status="voen_b1_file.status"
                          @img64="voen_b1_filem"
                        />
                      </div>
                      <div class="col-md-6">
                        <label for="select_3_5">Күбөлүк 2 <span>*</span></label>
                        <FotoBlock
                          :imgDefault="voen_b2_file.d"
                          :iwidth="voen_b2_file.w"
                          :iheight="voen_b2_file.h"
                          :status="voen_b2_file.status"
                          @img64="voen_b2_filem"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="stepBlock__item">
            <div class="card shadow-lg">
              <div class="card-header d-flex justify-content-between py-3">
                <span class="h_tema_3 mb-0">Ата-энеси жөнүндө маалымат:</span>
                <span class="h_tema_3 mb-0"><i class="fas fa-users"></i></span>
              </div>
              <div class="card-body p-3">
                <div class="form-group">
                  <label for="in_5_1"
                    >Атасы / Иштеген жери, кесиби / Телефону</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="father_info"
                    id="in_5_1"
                    placeholder=""
                    required
                  />
                </div>
                <div class="form-group">
                  <label for="in_5_2"
                    >Апасы / Иштеген жери, кесиби / Телефону</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    v-model="mother_info"
                    id="in_5_2"
                    placeholder=""
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="stepBlock__item">
            <div class="card shadow-lg">
              <div class="card-header d-flex justify-content-between py-3">
                <span class="h_tema_3 mb-0"
                  >Кызматкер: {{ getUser.name }}</span
                >
                <span class="h_tema_3 mb-0"><i class="fas fa-users"></i></span>
              </div>
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-md-12">
                    <div class="lblock">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <div class="form-check">
                              <!-- form-check-inline -->
                              <input
                                class="form-check-input"
                                type="radio"
                                name="type_diplom"
                                id="td1"
                                value="1"
                                v-model="type_diplom"
                                checked
                              />
                              <label class="form-check-label" for="td1">
                                Аттестат
                              </label>
                            </div>
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="type_diplom"
                                id="td2"
                                value="2"
                                v-model="type_diplom"
                              />
                              <label class="form-check-label" for="td2">
                                Диплом орто СПО
                              </label>
                            </div>
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="type_diplom"
                                id="td3"
                                value="3"
                                v-model="type_diplom"
                              />
                              <label class="form-check-label" for="td3">
                                Диплом жогорку ВПО
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <!-- <h5>Оригинал документ</h5> -->
                          <div class="custom-control custom-checkbox mb-4">
                            <input
                              class="custom-control-input"
                              type="checkbox"
                              value=""
                              id="defaultCheck1"
                              v-model="doc_original"
                            />
                            <label
                              class="custom-control-label"
                              for="defaultCheck1"
                            >
                              Оригинал документ
                            </label>
                          </div>

                          <div class="input-group mb-3 w-50">
                            <div class="input-group-prepend">
                              <label class="input-group-text" for="select_2_3"
                                >Тур <span>*</span></label
                              >
                            </div>
                            <select class="custom-select" id="" v-model="tur">
                              <option value="0" selected disabled>---</option>
                              <template v-if="map.tur != null">
                                <option
                                  v-for="item in map.tur"
                                  :key="item.id"
                                  :value="item.id"
                                >
                                  {{ item.name }}
                                </option>
                              </template>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6" v-if="false">
                    <div class="lblock">
                      <div class="row">
                        <div class="col-auto flex-grow-1">
                          <div class="form-group">
                            <label for="dp_1" class="font-weight-bold"
                              >Документ тапшырган: ФИО <span>*</span></label
                            >
                            <input
                              type="text"
                              class="form-control"
                              placeholder=""
                              id="dp_1"
                              v-model="fio_zdal_doc"
                            />
                          </div>
                        </div>
                        <div class="col-auto ml-auto">
                          <FotoBlock
                            :imgDefault="face_user_document_file.d"
                            :iwidth="face_user_document_file.w"
                            :iheight="face_user_document_file.h"
                            :status="face_user_document_file.status"
                            @img64="face_user_document_filem"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>       
        <div class="text-center my-5 footer_btn">
          <button type="button" class="btn btn-secondary mr-3" @click="goBack">
            <i class="anticon anticon-left"></i> Назад
          </button>
          <!-- <button type="submit" class="btn btn-success mr-3">Сохранить</button> -->

          <template v-if="statusEdit">            
            <button
              type="button"
              class="btn btn-success mr-3"
              :class="{ 'btn-tone': !status_proverka }"
              @click.prevent="formSubmit()"
            >
              <i class="anticon anticon-save"></i> Сохранить
            </button>

            <button
              type="button"
              class="btn btn-success mr-3"
              @click.prevent="setPrinyat(status_prinyat)"
              :disabled="!status_proverka"
              :class="{ 'btn-tone': !status_prinyat, 'btn-danger':  status_prinyat && isPrinyat}"
              @mouseover="isPrinyat = true" @mouseleave="isPrinyat = false"
            >
              <template v-if="status_prinyat && isPrinyat">
                <i class="anticon anticon-close"></i> Отозвать заявку
              </template>
              <template v-else>
                <i class="anticon anticon-check"></i> Принять заявку
              </template>
              
            </button>

            <button
              type="button"
              class="btn btn-success mr-3"
              @click.prevent="editModalShow"
              :disabled="!status_prinyat"
              :class="{ 'btn-tone': !status_print }"
            >
              <i class="anticon anticon-printer"></i> Печать
            </button>

            <button
              type="button"
              class="btn btn-success mr-3"
              @click.prevent="setExport"
              :disabled="!status_print"
              :class="{ 'btn-tone': !status_avn }"
            >
              <i class="anticon anticon-export"></i> Экспорт
            </button>
          </template>
          <template v-else>
            <button type="submit" class="btn btn-success mr-3">
              <i class="anticon anticon-save"></i> Сохранить
            </button>
          </template>
        </div>
      </form>
    </div>
    
    <Modal :isShow="isEditModalShow" @closeModal="editModalClose">
      <template v-slot:title> Печать </template>

      <template>
        <div class="row">
          <div class="col-md-4">
            <button type="button" class="btn btn-primary d-block w-100 mr-3" @click="printPDF('kg')">Кыргызча</button>
          </div>
          <div class="col-md-4">
            <button type="button" class="btn btn-primary d-block w-100 mr-3" @click="printPDF('ru')">Русский</button>
          </div>
          <div class="col-md-4">
            <button type="button" class="btn btn-primary d-block w-100 mr-3" @click="printPDF('en')">English</button>
          </div>
        </div>
                
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger"
          @click="editModalClose"
        >
          Отмена
        </button>        
      </template>
    </Modal>
    <Modal :isShow="isDeleteModalShow" @closeModal="deleteModalClose">
      <template v-slot:title> Отменить заявку </template>

      <template>
        <label for="ss">Причина</label>
        <textarea class="form-control" id="ss" rows="4" v-model="status_prinyat_info"></textarea>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="deleteModalClose"
        >
          Отмена
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click.prevent="otkaz"
        >
          Подтвердить
        </button>
      </template>
    </Modal>
    <template>
      <div>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="01"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="html2Pdf"
        >
          <section slot="pdf-content">
            <div class="pdfContainer">
              <template v-if="isCheckData">
                <div class="row mb-3">
                  <div class="col">
                    <img :src="foto34_file.d" class="userFoto" />
                  </div>
                  <div class="col text-center align-self-end">
                    <h2>{{pdft[lp].m1}}</h2>
                  </div>
                  <div class="col">
                    <div class="text-right">
                      <span class="text_v">{{pdft[lp].m2}}</span><br /><br />
                      {{pdft[lp].m3}}  {{nowYear.substring(2,4)}}/{{user.id }}
                    </div>
                  </div>
                </div>

                <div>
                  <span style="padding-left: 2em">{{pdft[lp].m4}}</span>
                  <span class="text_v px-2">{{ facultyname['name_'+lp] }}</span>
                  <span>{{pdft[lp].m5}} </span>
                
                  
                  <span class="text_v">{{ directionname.shifr }}. {{ directionname['name_'+lp] }}</span>
                  
                  <span class="text_v pr-2">[{{ spesname['name_'+lp] }}]</span>
                  <span>{{pdft[lp].m6}}</span>
                </div>
                <hr />
                <div class="d-flex mb-2">
                  <div class="info_block">
                    <span>{{pdft[lp].m7}}:</span>
                    <span class="text_v mx-2">{{ f_o_name['name_'+lp]}}</span>
                  </div>
                  <div class="info_block">
                    <span>{{pdft[lp].m8}}:</span>
                    <span class="text_v mx-2">{{ type_o_name['name_'+lp]}}</span>
                  </div>
                  <div class="info_block">
                    <span>{{pdft[lp].m9}}:</span>
                    <span class="text_v mx-2">{{ language_o_name['name_'+lp] }}</span>
                  </div>
                </div>
                <div class="section mb-2">{{pdft[lp].m10}}</div>
                <div class="row mb-2">
                  <div class="col br">
                    <div class="info_item">
                      <span>{{pdft[lp].m11}}:</span>
                      <span class="text_v mx-2">{{ user.f }}</span>
                    </div>
                    <div class="info_item">
                      <span>{{pdft[lp].m12}}:</span>
                      <span class="text_v mx-2">{{ user.i }}</span>
                    </div>
                    <div class="info_item">
                      <span>{{pdft[lp].m13}}:</span>
                      <span class="text_v mx-2">{{ user.o }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="info_item">
                      <span>{{pdft[lp].m14}}:</span>
                      <span class="text_v   px-2">{{ birthday }}</span>
                    </div>
                    <div class="info_item">
                      <span>{{pdft[lp].m15}}:</span>
                      <span class="text_v mx-2">{{ male_name['name_'+lp]}}</span>
                    </div>
                    <div class="info_item">
                      <span>{{pdft[lp].m16}}:</span>
                      <span class="text_v mx-2">{{
                        nationality_name['name_'+lp]
                      }}</span>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col br">
                    <div class="mr-2">{{pdft[lp].m17}}:</div>
                    <div class="text_v">{{ number_passport }}</div>
                  </div>
                  <div class="col br">
                    <div class="mr-2">{{pdft[lp].m18}}:</div>
                    <div class="text_v">{{ info_passport }}</div>
                  </div>
                  <div class="col">
                    <div class="mr-2">{{pdft[lp].m19}}:</div>
                    <div class="text_v">{{ pin }}</div>
                  </div>
                </div>
                <hr />
                <div class="info_item">
                  <span class="mr-2">{{pdft[lp].m20}}:</span>
                  <span>{{ citizenship_name['name_'+lp] }}</span>
                </div>
                <div class="info_item">
                  <span class=" mr-2">{{pdft[lp].m21}}:</span>
                  <span
                    >{{ country_name['name_'+lp] }}, {{ oblast_name['name_'+lp] }},
                    {{ rayon_name['name_'+lp] }}, {{ adress }}</span
                  >
                </div>
                <div class="info_item mb-2">
                  <span class="mr-2">{{pdft[lp].m22}}:</span>
                  <span
                    >{{ country_live_name['name_'+lp] }},
                    {{ oblast_live_name['name_'+lp] }},
                    {{ rayon_live_name['name_'+lp] }}, {{ adress_live }}</span
                  >
                </div>

                <div class="section mb-2">
                  {{pdft[lp].m23}}
                </div>
                <div class="row mb-2">
                  <div class="col-4 br">
                    <div class="info_item">
                      <span>{{pdft[lp].m24}}:</span>
                      <span class="text_v mx-2">{{
                        country_school_name['name_'+lp]
                      }}</span>
                    </div>
                    <div class="info_item">
                      <span>{{pdft[lp].m25}}:</span>
                      <span class="text_v mx-2"
                        >{{ oblast_school_name['name_'+lp] }}
                      </span>
                    </div>
                    <div class="info_item">
                      <span>{{pdft[lp].m26}}:</span>
                      <span class="text_v mx-2">{{
                        rayon_school_name['name_'+lp]
                      }}</span>
                    </div>
                  </div>
                  <div class="col-8">
                    <div class="info_item">
                      <span>{{pdft[lp].m27}}</span>
                      <span class="text_v px-2"
                        >{{ school_name['name_'+lp] }}
                      </span>
                    </div>
                    <div class="info_item">
                      <span>{{pdft[lp].m28}}</span>
                      <span class="text_v mx-2">{{ diplom_info }}</span>
                    </div>
                    <div class="info_item">
                      <span>{{pdft[lp].m29}}</span>
                      <span class="text_v mx-2">{{ school_year_end }}</span>
                    </div>
                    <div class="info_item">
                      <span>{{pdft[lp].m30}}:</span>
                      <span class="text_v mx-2">{{
                        language_studied_name['name_'+lp]
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="section mb-2">{{pdft[lp].m31}}</div>
                <div class="row">
                  <div class="col-4">
                    <div class="info_item">
                      <span>{{pdft[lp].m32}}:</span>
                      <span class="text_v mx-2">{{ ort_number }}</span>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="info_item">
                      <span>{{pdft[lp].m33}}:</span>
                      <span class="text_v mx-2">{{ ort_type_name['name_'+lp] }}</span>
                    </div>
                  </div>
                  <div class="col-3">
                    <div class="info_item text-right">
                      <span>{{pdft[lp].m34}}:</span>
                      <span class="text_v ml-2">{{ ort_ball1 }}</span>
                    </div>
                  </div>
                </div>
                <template v-if="ort_ball2 || ort_ball3">
                  <hr />
                  <div class="row mb-2">
                    <div class="col">
                      <div class="info_item">
                        <span>{{pdft[lp].m35}} 
                          <span class="text_v">
                            {{ ort_ball2_name_name['name_'+lp]}}: {{ ort_ball2}}
                          </span> {{pdft[lp].m48}}
                        </span>                      
                      </div>
                    </div>
                    <div class="col" v-if="ort_ball3">
                      <div class="info_item">
                        <span>{{pdft[lp].m35}} 
                          <span class="text_v">
                            {{ ort_ball3_name_name['name_'+lp]}}: {{ ort_ball3}}
                          </span> {{pdft[lp].m48}}
                        </span> 
                      </div>
                    </div>
                  </div>  
                </template>
                
                             
                
                <div class="section mb-2">
                  {{pdft[lp].m36}}
                </div>
                <div class="d-flex justify-content-between mb-2">
                  <div class="info_item mr-2">
                    <span>{{pdft[lp].m37}}:</span>
                    <span class="text_v mx-2">{{ voen_bilet_number }}</span>
                  </div>
                  <div class="info_item">
                    <span>{{pdft[lp].m38}}:</span>
                    <span class="text_v mx-2">{{ voen_bilet_info }}</span>
                  </div>
                </div>
                
                <div class="section mb-2">{{pdft[lp].m39}}</div>
                <div class="row mb-2">
                  <div class="col info_item">
                    <span>{{pdft[lp].m40}}:</span>
                    <span class="mx-2">{{ father_info }}</span>
                  </div>
                  <div class="col info_item">
                    <span>{{pdft[lp].m41}}:</span>
                    <span class="mx-2">{{ mother_info }}</span>
                  </div>
                </div>
                

                <div class="info_sm mb-2">{{pdft[lp].m42}}</div>

                <div class="d-flex justify-content-between mb-2">
                  <div class="info_item mr-2">
                    <span>{{pdft[lp].m43}}:</span>
                    <span class="mx-2">{{created_at}}</span>
                  </div>
                  <div class="info_item">
                    <span>{{pdft[lp].m44}}:</span>
                    <span class="b_b">_______________</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between mb-2">
                  <div class="d-flex">
                    <div class="mr-2">
                      <i class="anticon anticon-phone mr-1"></i> 
                      <span>{{mob_number}}</span>
                    </div>
                    <div class="mr-2">
                      <i class="anticon anticon-mail mr-1"></i> 
                      <span>{{email}}</span>
                    </div>
                  </div>
                  <div class="info_item">
                    <span>{{pdft[lp].m46}}:</span>
                    <span class="b_b">_______________</span>
                  </div>
                </div>
                <div class="d-flex justify-content-between align-items-end">
                  <div class="info_item mr-2">
                    <span>{{pdft[lp].m45}}:</span>
                    <span class="mx-2 b_b"
                      >____________________________</span
                    >
                  </div>
                  <div class="footer">{{pdft[lp].m47}} {{nowYear}}</div>
                 </div>
              </template>
            </div>
          </section>
        </vue-html2pdf>
      </div>
    </template>
  </div>
</template>
<script>

import FotoBlock from "@/components/others/FotoBlock2.vue";
import Fileinput from "@/components/others/Fileinput.vue";
import Modal from "@/components/others/Modal.vue";
import VueHtml2pdf from "vue-html2pdf";

import { mapGetters } from "vuex";

import sLocales from "@/locales/index.js";


export default {
  name: "Statement",
  components: {
    FotoBlock,
    VueHtml2pdf,
    Fileinput,
    Modal
  },
  data() {
    return {
      isPrinyat: false,
      isEditModalShow: false,
      isDeleteModalShow: false,
      pdft: sLocales,
      nowYear: (new Date().getFullYear()).toString(),
      lp: 'kg',
      lps: ['kg', 'ru', 'en'],
      message: [],
      statusEdit: 0,
      status_prinyat: null,
      status_print: null,
      status_avn: null,
      status_proverka: null,
      status_prinyat_info: '',
      map: {
        tur: null,
        male: null,
        lang: null,
        nationality: null,
        language_studied: null,
        ort_type: null,
        ort_predmet_name: null,
      },

      foto34_file: { img: null, d: null, status: 1, w: "120px", h: "152px" },
      passport1_file: {
        img: null,
        d: null,
        status: 2,
        w: "150px",
        h: "98px",
        t: "Паспорт 1",
      },
      passport2_file: {
        img: null,
        d: null,
        status: 2,
        w: "150px",
        h: "98px",
        t: "Паспорт 2",
      },
      attestat1_file: { img: null, d: null, status: 2, w: "200px", h: "135px" },
      attestat2_file: { img: null, d: null, status: 2, w: "200px", h: "135px" },
      attestat3_file: { img: null, d: null, status: 2, w: "200px", h: "135px" },
      attestat4_file: { img: null, d: null, status: 2, w: "200px", h: "135px" },
      voen_b1_file: { img: null, d: null, status: 2, w: "200px", h: "135px" },
      voen_b2_file: { img: null, d: null, status: 2, w: "200px", h: "135px" },
      ort_file: { img: null, d: null, status: 3, w: "157px", h: "200px" },
      face_user_document_file: {
        img: null,
        d: null,
        status: 1,
        w: "120px",
        h: "152px",
      },

      perevod_file: { pdf: null, d: "" },

      graduation: null,

      user: { id: null, f: null, i: null, o: null },
      birthday: null,

      lang: 0,
      male: 0,
      language_studied: 0,
      nationality: 0,
      ort_ball2_name: null,
      ort_ball3_name: null,
      ort_type: 0,
      tur: 0,
      ort_ball1: "",
      ort_ball2: "",
      ort_ball3: "",
      ort_number: "",
      number_passport: "",
      info_passport: "",
      pin: "",
      school_year_end: new Date().getFullYear(),
      diplom_info: "",

      edu: {
        country: { disabled: true, items: null, val: 0 },
        oblast: { disabled: true, items: null, val: 0 },
        rayon: { disabled: true, items: null, val: 0 },
        mektep: { disabled: true, items: null, val: 0 },
      },
      place: {
        country: { disabled: true, items: null, val: 0 },
        oblast: { disabled: true, items: null, val: 0 },
        rayon: { disabled: true, items: null, val: 0 },
      },
      adress: "",

      live: {
        country: { disabled: true, items: null, val: 0 },
        oblast: { disabled: true, items: null, val: 0 },
        rayon: { disabled: true, items: null, val: 0 },
      },
      adress_live: "",

      citizenship: { disabled: true, items: null, val: 0 },

      fak: { disabled: true, items: null, val: 0 },
      direction: { disabled: true, items: null, val: 0 },
      spec: { disabled: true, items: null, val: 0 },
      type_o: { disabled: true, items: null, val: 0 },
      f_o: { disabled: true, items: null, val: 0 },

      father_info: "",
      mother_info: "",
      voen_bilet_number: "",
      voen_bilet_info: "",

      fio_zdal_doc: "",
      type_diplom: 1,
      doc_original: true,
      isCheckData: false,
      foto34: null,
      

      // for PDF
      facultyname: { name_kg: "", name_ru: "", name_en: ""},
      directionname: { name_kg: "", name_ru: "", name_en: "", shifr: "" },
      spesname: { name_kg: "", name_ru: "", name_en: "" },
      f_o_name: { name_kg: "", name_ru: "", name_en: "" },
      type_o_name: { name_kg: "", name_ru: "", name_en: "" },

      citizenship_name: { name_kg: "", name_ru: "", name_en: "" },
      country_name: { name_kg: "", name_ru: "", name_en: "" },
      oblast_name: { name_kg: "", name_ru: "", name_en: "" },
      rayon_name: { name_kg: "", name_ru: "", name_en: "" },

      country_live_name: { name_kg: "", name_ru: "", name_en: "" },
      oblast_live_name: { name_kg: "", name_ru: "", name_en: "" },
      rayon_live_name: { name_kg: "", name_ru: "", name_en: "" },

      country_school_name: { name_kg: "", name_ru: "", name_en: "" },
      oblast_school_name: { name_kg: "", name_ru: "", name_en: "" },
      rayon_school_name: { name_kg: "", name_ru: "", name_en: "" },
      school_name: { name_kg: "", name_ru: "", name_en: "" },

      language_o_name: { name: "" },
      language_studied_name: { name: "" },
      male_name: { name: "" },
      nationality_name: { name: "" },
      ort_ball2_name_name: { name: "" },
      ort_ball3_name_name: { name: "" },
      ort_type_name: { name: "" },
      tur_name: { name: "" },
      created_at: '',
      email: '',
      mob_number: ''

    };
  },
  computed: {
    ...mapGetters({
      getUser: 'user/getUser'
    }),
  },
  
  methods: {
    printPDF(l){
      this.lp = l
      this.editModalClose()
      this.$refs.html2Pdf.generatePdf();
      this.status_print_api();
    },
    editModalShow() {
      this.isEditModalShow = true;
    },
    editModalClose() {
      this.isEditModalShow = false;
    },
    deleteModalShow() {
      this.isDeleteModalShow = true;         
    },
    deleteModalClose() {
      this.isDeleteModalShow = false;
    },
    goBack() {
      if (this.statusEdit) {
        this.$router.push({
          name: "DocumentsList",
          params: {
            status: 1,
            fak: this.fak.val,
            direction: this.direction.val,
            spec: this.spec.val,
            type_o: this.type_o.val,
            f_o: this.f_o.val,
            tur: this.tur,
          },
        });
      } else this.$router.push({ name: "ApplicantsList" });
    },

    foto34_filem(file) {
      this.foto34_file.img = file;
    },
    passport1_filem(file) {
      this.passport1_file.img = file;
    },
    passport2_filem(file) {
      this.passport2_file.img = file;
    },
    attestat1_filem(file) {
      this.attestat1_file.img = file;
    },
    attestat2_filem(file) {
      this.attestat2_file.img = file;
    },
    attestat3_filem(file) {
      this.attestat3_file.img = file;
    },
    attestat4_filem(file) {
      this.attestat4_file.img = file;
    },
    ort_filem(file) {
      this.ort_file.img = file;
    },
    voen_b1_filem(file) {
      this.voen_b1_file.img = file;
    },
    voen_b2_filem(file) {
      this.voen_b2_file.img = file;
    },
    face_user_document_filem(file) {
      this.face_user_document_file.img = file;
    },
    pdfFile(file) {
      this.perevod_file.pdf = file;
    },
    formSubmit() {
      this.add_list();
    },
    async add_list() {
      try {
        await this.$api.documents.add_list({
          id_user: this.user.id,

          // Направления
          id_faculty: this.fak.val,
          id_direction: this.direction.val,
          id_spes: this.spec.val,
          id_type_o: this.type_o.val,
          id_f_o: this.f_o.val,
          id_language_o: this.lang,

          // Жеке маалымат
          f: this.user.f,
          i: this.user.i,
          o: this.user.o,
          birthday: this.birthday,
          male: this.male,
          nationality: this.nationality,
          number_passport: this.number_passport,
          info_passport: this.info_passport,
          pin: this.pin,
          foto34_file: this.foto34_file.img,
          passport1_file: this.passport1_file.img,
          passport2_file: this.passport2_file.img,

          id_citizenship: this.citizenship.val,

          // Туулган жери
          id_country: this.place.country.val,
          id_oblast: this.place.oblast.val,
          id_rayon: this.place.rayon.val,
          adress: this.adress,
          // Жашаган жери
          id_country_live: this.live.country.val,
          id_oblast_live: this.live.oblast.val,
          id_rayon_live: this.live.rayon.val,
          adress_live: this.adress_live,

          // Бүтүргөн мектеби/окуу жайы боюнча маалымат
          id_country_school: this.edu.country.val,
          id_oblast_school: this.edu.oblast.val,
          id_rayon_school: this.edu.rayon.val,
          id_school: this.edu.mektep.val,
          school_year_end: this.school_year_end,
          diplom_info: this.diplom_info,
          language_studied: this.language_studied,
          attestat1_file: this.attestat1_file.img,
          attestat2_file: this.attestat2_file.img,
          attestat3_file: this.attestat3_file.img,
          attestat4_file: this.attestat4_file.img,
          perevod_file: this.perevod_file.pdf,

          // ОРТ боюнча маалымат
          ort_number: this.ort_number,
          ort_type: this.ort_type,
          ort_ball1: this.ort_ball1,
          ort_ball2_name: this.ort_ball2_name,
          ort_ball2: this.ort_ball2,
          ort_ball3_name: this.ort_ball3_name,
          ort_ball3: this.ort_ball3,
          ort_file: this.ort_file.img,

          // Аскердик билет/Приписной(Күбөлүк):
          voen_bilet_number: this.voen_bilet_number,
          voen_bilet_info: this.voen_bilet_info,
          voen_b_file: this.voen_b1_file.img,
          voen_b2_file: this.voen_b2_file.img,

          // Ата-энеси жөнүндө маалымат:
          father_info: this.father_info,
          mother_info: this.mother_info,
          // Other
          type_diplom: this.type_diplom,
          doc_original: this.doc_original ? 1 : 0,
          id_tur: this.tur,
          fio_zdal_doc: this.fio_zdal_doc,
          face_user_document_file: this.face_user_document_file.img,
          // status_proverka: 1,
        });
        this.$nt("Успешно сахранен", "success");
        this.status_proverka = 1
        if (!this.statusEdit) this.goBack();
        else this.chek_document();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка сохранения", "dagner");
      }
    },

    async getCountry() {
      try {
        const data = (await this.$api.place.country()).data;
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    async getOblast(a) {
      try {
        const data = (
          await this.$api.place.oblast({
            id_country: a.country.val,
          })
        ).data;
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    async getRayon(a) {
      try {
        const data = (
          await this.$api.place.rayon({
            id_oblast: a.oblast.val,
          })
        ).data;
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    async getMektep() {
      try {
        const data = (
          await this.$api.place.mektep({
            id_rayon: this.edu.rayon.val,
          })
        ).data;
        return data;
      } catch (error) {
        console.log(error);
      }
    },
    async getFak() {
      try {
        const data = (await this.$api.edu_spec.faculty()).data;
        this.fak.items = data;
        this.fak.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getDirection() {
      try {
        const data = (
          await this.$api.edu_spec.direction({
            id_faculty: this.fak.val,
          })
        ).data;
        this.direction.items = data;
        this.direction.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getSpec() {
      try {
        const data = (
          await this.$api.edu_spec.speciality({
            id_direction: this.direction.val,
          })
        ).data;
        this.spec.items = data;
        this.spec.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getType_o() {
      try {
        const data = (
          await this.$api.edu_spec.type_o({
            id_spes: this.spec.val,
          })
        ).data;
        this.type_o.items = data;
        this.type_o.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getF_o() {
      try {
        const data = (
          await this.$api.edu_spec.f_o({
            id_type_o: this.type_o.val,
            id_spes: this.spec.val,
          })
        ).data;
        this.f_o.items = data;
        this.f_o.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async list_info() {
      try {
        const data = (
          await this.$api.map.list_info({
            id_document: this.user.id,
          })
        ).data;
        this.map = data;
      } catch (error) {
        console.log(error);
      }
    },
    async chek_document() {
      try {
        const data = (
          await this.$api.documents.chek_document({
            id_document: this.$route.params.id,
          })
        ).data;
        this.isCheckData = true;
        let storeUrl = "https://registration.portal.oshsu.kg/storage";

          let df = data.document_file;
          let dt = data.document_text;

          // Направления
          this.fak.val = dt.id_faculty;
          this.getDirection();
          this.direction.val = dt.id_direction;
          this.getSpec();
          this.spec.val = dt.id_spes;
          this.getType_o();
          this.type_o.val = dt.id_type_o;
          this.getF_o();
          this.f_o.val = dt.id_f_o;
          this.lang = dt.id_language_o;

          // Жеке маалымат
          this.user.id = dt.id_user;
          this.user.f = dt.f;
          this.user.i = dt.i;
          this.user.o = dt.o;
          this.birthday = dt.birthday;
          this.male = dt.male;
          this.nationality = dt.nationality;
          this.number_passport = df.number_passport;
          this.info_passport = df.info_passport;
          this.pin = dt.pin;
          if (df.foto34_file)
            this.foto34_file.d = storeUrl + "/photo34/" + df.foto34_file;
          if (df.passport1_file)
            this.passport1_file.d = storeUrl + "/doc/" + df.passport1_file;
          if (df.passport2_file)
            this.passport2_file.d = storeUrl + "/doc/" + df.passport2_file;

          // Туулган жери
          this.citizenship.val = dt.id_citizenship;
          this.place.country.val = dt.id_country;
          this.getOblast(this.place).then((data) => {
            this.place.oblast.items = data;
          });
          this.place.oblast.val = dt.id_oblast;
          this.getRayon(this.place).then((data) => {
            this.place.rayon.items = data;
          });
          this.place.rayon.val = dt.id_rayon;
          this.adress = dt.adress;

          this.live.country.val = dt.id_country_live;
          this.getOblast(this.live).then((data) => {
            this.live.oblast.items = data;
          });
          this.live.oblast.val = dt.id_oblast_live;
          this.getRayon(this.live).then((data) => {
            this.live.rayon.items = data;
          });
          this.live.rayon.val = dt.id_rayon_live;
          this.adress_live = dt.adress_live;

          // Бүтүргөн мектеби/окуу жайы боюнча маалымат
          this.edu.country.val = dt.id_country_school;
          this.getOblast(this.edu).then((data) => {
            this.edu.oblast.items = data;
          });
          this.edu.oblast.val = dt.id_oblast_school;
          this.getRayon(this.edu).then((data) => {
            this.edu.rayon.items = data;
          });
          this.edu.rayon.val = dt.id_rayon_school;
          this.getMektep().then((data) => {
            this.edu.mektep.items = data;
          });
          this.edu.mektep.val = dt.id_school;
          this.school_year_end = dt.school_year_end;
          this.diplom_info = dt.diplom_info;
          this.language_studied = dt.language_studied;
          if (df.attestat1_file)
            this.attestat1_file.d = storeUrl + "/doc/" + df.attestat1_file;
          if (df.attestat2_file)
            this.attestat2_file.d = storeUrl + "/doc/" + df.attestat2_file;
          if (df.attestat3_file)
            this.attestat3_file.d = storeUrl + "/doc/" + df.attestat3_file;
          if (df.attestat4_file)
            this.attestat4_file.d = storeUrl + "/doc/" + df.attestat4_file;
          if (df.perevod_file)
            this.perevod_file.d = storeUrl + "/doc/" + df.perevod_file;

          // ОРТ боюнча маалымат
          this.ort_number = dt.ort_number;
          this.ort_type = dt.ort_type;
          this.ort_ball1 = dt.ort_ball1;
          this.ort_ball2_name = dt.ort_ball2_name;
          this.ort_ball2 = dt.ort_ball2;
          this.ort_ball3_name = dt.ort_ball3_name;
          this.ort_ball3 = dt.ort_ball3;
          if (df.ort_file) this.ort_file.d = storeUrl + "/doc/" + df.ort_file;

          // Аскердик билет/Приписной(Күбөлүк):
          this.voen_bilet_number = df.voen_bilet_number;
          this.voen_bilet_info = df.voen_bilet_info;
          if (df.voen_b_file)
            this.voen_b1_file.d = storeUrl + "/doc/" + df.voen_b_file;
          if (df.voen_b2_file)
            this.voen_b2_file.d = storeUrl + "/doc/" + df.voen_b2_file;

          // Ата-энеси жөнүндө маалымат:
          this.mother_info = df.mother_info;
          this.father_info = df.father_info;
          // Other
          this.type_diplom = dt.type_diplom;
          (this.doc_original = dt.doc_original ? true : false),
            (this.tur = dt.id_tur);
          this.fio_zdal_doc = df.fio_zdal_doc;
          if (df.face_user_document_file)
            this.face_user_document_file.d =
              storeUrl + "/doc/" + df.face_user_document_file;
          // Status
          this.status_prinyat = !!dt.status_prinyat;
          this.status_print = !!dt.status_print;
          this.status_avn = !!dt.status_avn;
          this.status_proverka = !!dt.status_proverka

          // if(dt.status_proverka==1) this.status_proverka=true

          // For PDF

          this.facultyname = dt.facultyname || "";
          this.directionname = dt.directionname || "";
          this.spesname = dt.spesname || "";
          this.f_o_name = dt.f_o_name || "";
          this.type_o_name = dt.type_o_name || "";

          this.citizenship_name = dt.citizenship_name || "";
          this.country_name = dt.country_name || "";
          this.oblast_name = dt.oblast_name || "";
          this.rayon_name = dt.rayon_name || "";

          this.country_live_name = dt.country_live_name || "";
          this.oblast_live_name = dt.oblast_live_name || "";
          this.rayon_live_name = dt.rayon_live_name || "";

          this.country_school_name = dt.country_school_name || "";
          this.oblast_school_name = dt.oblast_school_name || "";
          this.rayon_school_name = dt.rayon_school_name || "";
          this.school_name = dt.school_name || "";

          this.language_o_name = dt.language_o_name || "";
          this.language_studied_name = dt.language_studied_name || "";
          this.male_name = dt.male_name || "";
          this.nationality_name = dt.nationality_name || "";
          this.ort_ball2_name_name = dt.ort_ball2_name_name || "";
          this.ort_ball3_name_name = dt.ort_ball3_name_name || "";
          this.ort_type_name = dt.ort_type_name || "";
          this.tur_name = dt.tur_name || "";
          this.created_at = new Date(dt.created_at).toLocaleDateString()
          this.email = dt.user_info.email || "---",
          this.mob_number = dt.user_info.mob_number || "---"
      } catch (error) {
        console.log(error);
      }
    },
    async status_api(s) {
      try {
        const data = (await this.$api.others.status({
          id_user: this.user.id,
          status: s,
          status_prinyat_info: this.status_prinyat_info
        })).data
        if (data==1) this.status_prinyat = true
        else  this.status_prinyat = false
        this.$nt("Статус изменен", "success");
      } catch (error) {
        console.log(error);
      }
    },
    async status_print_api() {
      try {
        await this.$api.others.status_print({
          id_user: this.user.id,
          status: 1,
        });
        this.status_print = 1;
        this.$nt("Статус изменен", "success");
      } catch (error) {
        console.log(error);
      }
    },
    async status_avn_api() {
      try {
        await this.$api.others.status_avn({
          // id_user: this.user.id,
          id_user: this.$route.params.id,
          status: 1,
        });
        this.status_avn = 1;
        this.$nt("Статус изменен", "success");
      } catch (error) {
        console.log(error);
      }
    },

    counterSelect() {
      this.edu.oblast.val = 0;
      this.edu.rayon.val = 0;
      this.edu.rayon.disabled = true;
      this.edu.mektep.val = 0;
      this.edu.mektep.disabled = true;
      this.getOblast(this.edu).then((data) => {
        this.edu.oblast.items = data;
        this.edu.oblast.disabled = false;
      });
    },
    oblastSelect() {
      this.edu.rayon.val = 0;
      this.edu.mektep.val = 0;
      this.edu.mektep.disabled = true;
      this.getRayon(this.edu).then((data) => {
        this.edu.rayon.items = data;
        this.edu.rayon.disabled = false;
      });
    },
    rayontSelect() {
      this.edu.mektep.val = 0;
      this.getMektep().then((data) => {
        this.edu.mektep.items = data;
        this.edu.mektep.disabled = false;
      });
    },
    placeCounterSelect() {
      this.place.oblast.val = 0;
      this.place.rayon.val = 0;
      this.place.rayon.disabled = true;
      this.getOblast(this.place).then((data) => {
        this.place.oblast.items = data;
        this.place.oblast.disabled = false;
      });
    },
    placeOblastSelect() {
      this.place.rayon.val = 0;
      this.getRayon(this.place).then((data) => {
        this.place.rayon.items = data;
        this.place.rayon.disabled = false;
      });
    },
    liveCounterSelect() {
      this.live.oblast.val = 0;
      this.live.rayon.val = 0;
      this.live.rayon.disabled = true;
      this.getOblast(this.live).then((data) => {
        this.live.oblast.items = data;
        this.live.oblast.disabled = false;
      });
    },
    liveOblastSelect() {
      this.live.rayon.val = 0;
      this.getRayon(this.live).then((data) => {
        this.live.rayon.items = data;
        this.live.rayon.disabled = false;
      });
    },

    fakSelect() {
      this.direction.val = 0;
      this.spec.val = 0;
      this.spec.disabled = true;
      this.type_o.val = 0;
      this.type_o.disabled = true;
      this.f_o.val = 0;
      this.f_o.disabled = true;
      this.getDirection();
    },
    directionSelect() {
      this.spec.val = 0;
      this.type_o.val = 0;
      this.type_o.disabled = true;
      this.f_o.val = 0;
      this.f_o.disabled = true;
      this.getSpec();
    },
    specSelect() {
      this.type_o.val = 0;
      this.f_o.val = 0;
      this.f_o.disabled = true;
      this.getType_o();
    },
    type_oSelect() {
      this.f_o.val = 0;
      this.f_o.disabled = true;
      this.getF_o();
    },
    setPrinyat(s) {
      if (!s) {
        this.status_api(1);
      } else {
        this.deleteModalShow()
      }      
    },
    setExport() {
      this.status_avn_api();
    },
    otkaz(){
      this.status_api(2)
      this.deleteModalClose()    
      this.status_prinyat_info = ''
    }
  },
  beforeCreate(){
    if(!this.$route.params.id){
      this.$router.push({name: 'DocumentsList'})
    }
  },
  created() {
    this.statusEdit = this.$route.params.status;
    this.user.id = this.$route.params.id;
  },
  mounted() {
    this.$nextTick(function () {
      this.getCountry().then((data) => {
        this.edu.country.items = data;
        this.edu.country.disabled = false;
        this.place.country.items = data;
        this.place.country.disabled = false;
        this.live.country.items = data;
        this.live.country.disabled = false;
        this.citizenship.items = data;
        this.citizenship.disabled = false;
      });
      this.getFak();
      this.list_info();

      if (this.statusEdit == 1) {
        this.chek_document()
      } else {
        this.user.f = this.$route.params.f;
        this.user.i = this.$route.params.i;
        this.user.o = this.$route.params.o;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.pdfContainer {
  color: #000;
  padding: 35px;
  .userFoto {
    width: 100px;
    border: 1px dashed gray;
    padding: 3px;
  }
  .text_v {
    font-weight: 500;
  }
  hr {
    border-top: 1px dashed #c9c9c9;
    margin-top: 7px;
    margin-bottom: 5px;
  }
  .info_block {
    margin-right: 1.5em;
  }
  .br {
    border-right: 1px dashed #c9c9c9;
  }
  .section {
    background-color: rgb(212, 212, 212);
    color: rgb(0, 0, 0);
    padding: 3px 5px;
    font-weight: 500;
    text-align: center;
  }
  .info_sm {
    background-color: #e0e0e0;
    font-size: 10px;
    color: rgb(0, 0, 0);
    line-height: 12px;
    padding: 5px 5px;
  }
  .footer {
    font-size: 0.7em;
    text-align: right;
    font-weight: 100;
    text-transform: uppercase;
    color: #000;
    padding: 0;
  }
  .b_b {
    color: gray;
  }
}
.footer_btn {
  .btn-success {
    &.btn-tone {
      border-color: #00c9a7;
    }
    &[disabled],
    &[disabled]:hover {
      cursor: not-allowed;
      color: #8ea5a1;
      border-color: #8ea5a1 !important;
      background-color: #f1f2f3 !important;
      border-color: #edf2f9;
    }
  }
  .btn-primary.btn-tone {
    border-color: #3f87f5;
  }
}
</style>
